import { GridToolbarContainer, GridToolbarColumnsButton, GridToolbarExport } from '@mui/x-data-grid';

export function CustomToolbar() {
    return (
        <GridToolbarContainer sx={{ background: 'var(--DataGrid-containerBackground)' }}>
            <GridToolbarColumnsButton  />
            <GridToolbarExport />
        </GridToolbarContainer>
    )
}
